import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SiteServices } from '../../services/siteservices';

import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';

// import { ChipsModule, InputTextModule } from '../../lib/primeng/primeng';
import { CategoryComponent } from './category.main';
import { ModalDialogModule } from 'ngx-modal-dialog';
import { FileUploadModule } from 'ng2-file-upload';
import { EnvironmentServices } from '../../services/evironment.service';

@NgModule({
    declarations: [CategoryComponent],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        AlertModule.forRoot(),
        ModalDialogModule.forRoot(),
        ModalModule.forRoot(),
        FileUploadModule,
    ],
    providers: [SiteServices, EnvironmentServices],

    bootstrap: [CategoryComponent],
})
export class CategoryModule {}
